const menuRouteMap = {
    "新生报到":'StudentReport',
    "报到材料":'CheckInMaterials',
    "新生录取通知书":'LetterAdmission',
    "在线学习":'OnlineLearning',
    "补考安排":'MakeUpExam',
    "成绩查询":'ScoreQuery',
    "个人信息":'UserInfo',
    "学籍卡":'TemplateInfo',
    "毕业生登记表":'TemplateInfo',
    "录取通知书":'TemplateInfo',
    "学籍照片上传":'StudentPhoto',
    "毕业照片上传":'GraduatePhoto',
    "我的消息":'MyNews',
    "修改密码":'EditPassword',
    "通知公告":'Notice',
    "问卷调查":'QuestionnaireList',
    "教师评价":'TeacherEvaluateList',
    "课程直播":'LivePlan',
    "论文要求":'ask',
    "论文报名":'application',
    "论文写作":'write',
    "论文查重":'check',
    "课表查询":'TimetableQuery',
    "教学计划":'TeachingPlan',
    "选课中心":'CourseSelectionCenter',
    "我的财务":'MyFinances',
    "资料下载":'DataDownload',
    "查重":'duplicateCheck'
}
export default menuRouteMap;



// WEBPACK FOOTER //
// ./src/common/menu.js